export default __webpack_public_path__ + "static/media/face_1.effe95bc.png";